module.exports = __webpack_public_path__ + "img/icon-remove-red.f698d6c6.svg";